import {useEffect, ReactElement, useState, createContext} from 'react'
import Home from './Home';
import POEditor from './POEditor';
import SOTool from './SOTool';
import PASOverview from './PASOverview';
import PASDetailed from './PASDetailed';
import Lists from "./Lists"
import Scenarios from './Scenarios';
import { Routes, Route, } from "react-router-dom";
import {useAllData, AllDataDone, dummyAllDataDoneObject} from "./alldata"
import {LoadAllDataPage} from "./LoadAllDataPage"

export type AllDataState = "errorsNotDismissed" | "done"

export const AllDataContext = createContext<AllDataDone>(dummyAllDataDoneObject)


type Props = {
  setDataRetrievedTime: (time: Date | undefined) => void
  setNrErrorsAndWarnings: (nrErrorsAndWarnings: [number, number] | undefined) => void
}

export function LoggedinMainPage(
    {setDataRetrievedTime, setNrErrorsAndWarnings}: Props): ReactElement {
  const allData = useAllData()
  ;(window as any).__allData = allData
  const [allDataState, setAllDataState] =
    useState<AllDataState>("errorsNotDismissed")

  useEffect(() => {
    setAllDataState("errorsNotDismissed")
  }, [allData.division])

  useEffect(() => {
    setDataRetrievedTime(allData.done ? allData.firstDataRetrieved : undefined)
  }, [setDataRetrievedTime, allData])

  useEffect(() => {
    setNrErrorsAndWarnings(allData.done ?
      [allData.errors.length, allData.warnings.length]: undefined)
  }, [setNrErrorsAndWarnings, allData])

  if (allData.done === false || allDataState !== "done") {
    return <LoadAllDataPage allData={allData} allDataState={allDataState}
      setAllDataState={setAllDataState} />
  }

  return  (
    <AllDataContext.Provider value={allData}>
      <Routes>
        <Route index element={
          <Home />
        } />
        <Route path="Lists"
          element={<Lists /> } >
          <Route path={
            [ "itemToShow",
            ":itemToShow",
            ":filter",
            "groupBy",
            ":groupBy",
            "sortBy",
            ":sortBy",
          ].join("/")} element={<div>Should not be shown</div>} />
        </Route>
        <Route path="Scenarios"
          element={<Scenarios /> } >
          <Route path={
            [ "warehouse",
            ":warehouseCode",
            "scenariolines",
            ":scenarioLines",
          ].join("/")} element={<div>Should not be shown</div>} />
          <Route path={
            [ "warehouse",
            ":warehouseCode",
            "scenariolines",
          ].join("/")} element={<div>Should not be shown</div>} />
        </Route>
        <Route path="PASDetailed"
          element={<PASDetailed /> } >
          <Route path={
            [ ":warehouseCode",
            ":itemCode",
          ].join("/")} element={<div>Should not be shown</div>}>
            <Route path={
              [ ":warningLevel",
              ":infoLevel",
            ].join("/")} element={<div>Should not be shown</div>} />
          </Route>
        </Route>
        <Route path="POEditor/"
          element={<POEditor />} >
          <Route path="shippingAggregate/:shippingAggregate"
            element={<div>Should not be shown</div>} />
        </Route>
        <Route path="SOTool/"
          element={<SOTool />} >
          <Route path="warehouse/:warehouseCode/:firstDate"
            element={<div>Should not be shown</div>} />
        </Route>
        <Route path="PASOverview"
          element={<PASOverview /> }>
          <Route path="warehouse/:warehouseCode/overviewLines/"
            element={<div>Should not be shown</div>}>
            <Route path=":overviewLines"
              element={<div>Should not be shown</div>} />
          </Route>
        </Route>
        <Route path="*" element={
          <div>There is nothing here</div>} />
      </Routes>
    </AllDataContext.Provider>
  )

}
